import { store } from "../../Redux/ConfigureStore";
import {
  skillsDetails,
  p_skillsDetails,
  dispatchActivites,
  dispatchEducation,
  updateSkills,
  updateExperience,
  updateSoft_skills,
  saveExperience,
  saveSkills,
  yof_success,
  uppdateYOF,
} from "../../Redux/ActionCreator";
import { saveIntoServerCache } from "../saveIntoCache"
import { computeTotalExperience } from "../experience"

// Function to capitalize the first character of a string
function capitalizeFirstChar(text) {
    return text?.charAt(0)?.toUpperCase() + text?.slice(1);
}

export const GPTTechSkillServiceFilteringFromExp = (skills) => async (dispatch) => {
    console.log("Skills", skills);
    const store_value = store.getState();
    const tSkills = store_value.skills.skills;
    const newMap = new Map();
    let arr = new Array();
    let T_arr = new Array();
    if (tSkills !== null) {
        tSkills?.forEach(element => {
            if (element?.value !== undefined) {
                T_arr.push(element.value);
            } else {
                T_arr.push(element);
            }
        })
    }
    if (!Array.isArray(skills)) {
        if (typeof skills == "string") {
            skills = skills.split(/,|\.\s|\t|\n/)
        }
    }
    skills?.forEach(element => {
        if (!T_arr.includes(element)) {
            if (!newMap.has(element)) {
                newMap.set(element, true);
                arr.push(element);
            }
        }
    })
    if (arr.length != 0) {
        T_arr.forEach(element => {
            if (!newMap.has(element)) {
                newMap.set(element, true);
                arr.push(element);
            }
        })
    }
    arr = arr?.map(e => e?.toLowerCase());
    arr = [... new Set(arr)];
    arr = arr?.map(e => capitalizeFirstChar(e));
    dispatch(skillsDetails([... new Set(arr)]));
    saveIntoServerCache("technicalSkills", [... new Set(arr)]);
    let stor = store.getState();
    let p_profile = stor.profile;
    if (p_profile.message !== null) {
        dispatch(updateSkills([... new Set(arr)]))
    }
}


export const GPTPersonalSkillServiceFilteringFromExp = (skills) => async (dispatch) => {
    const store_value = store.getState();
    const pSkills = store_value.p_skills.p_skills;
    const newMap = new Map();
    let arr = new Array();
    let P_arr = new Array();
    if (pSkills !== null) {
        pSkills?.forEach(element => {
            if (element?.value !== undefined) {
                P_arr.push(element.value);
            } else {
                P_arr.push(element);
            }
        })
    }
    if (!Array.isArray(skills)) {
        if (typeof skills == "string") {
            skills = skills.split(/,|\.\s|\t|\n/)
        }
    }
    skills?.forEach(element => {
        if (!P_arr.includes(element)) {
            if (!newMap.has(element)) {
                newMap.set(element, true);
                arr.push(element);
            }
        }
    })
    if (arr.length != 0) {
        P_arr.forEach(element => {
            if (!newMap.has(element)) {
                newMap.set(element, true);
                arr.push(element);
            }
        })
    }
    arr = arr?.map(e => e?.toLowerCase());
    arr = [... new Set(arr)];
    arr = arr.map(e => capitalizeFirstChar(e));
    dispatch(p_skillsDetails([... new Set(arr)]));
    saveIntoServerCache("personalSkills", [... new Set(arr)]);
    let stor = store.getState();
    let p_profile = stor.profile;
    if (p_profile.message !== null) {
        dispatch(updateSoft_skills([... new Set(arr)]));
    }
}

export const extractLatestThreeExperiences = (experiences, flag) => async (dispatch) => {
    // Helper function to convert a date string to a Date object.
    // If the date is "Present", assign a far-future date.
    console.log("was called")
    function parseEndDate(dateStr) {
      if (typeof dateStr === 'string' && dateStr.trim().toLowerCase() === "present") {
        // Use a far-future date to ensure "Present" is always the most recent.
        return new Date(3000, 0, 1); // January 1, 3000
      }
      // For other dates like "January 2023", the Date constructor can parse them.
      return new Date(dateStr);
    }

    // Sort the experiences by Work_end_date in descending order.
    const sortedExperiences = experiences.sort((a, b) => {
      const dateA = parseEndDate(a.Work_end_date);
      const dateB = parseEndDate(b.Work_end_date);
      return dateB - dateA; // descending order
    });

    dispatch(dispatchActivites(sortedExperiences));
  
    // Return the latest three experiences.
    let lastThreeExp = sortedExperiences.slice(0, 3);
    console.log("lastThreeExp",lastThreeExp)
    let skills = [...new Set([lastThreeExp?.flatMap(e => (e.Skills))])];
    console.log("skills",skills)
    dispatch(skillsDetails(...[...new Set(skills)]));

    // calculate the year of experience
    let yof = computeTotalExperience(sortedExperiences);
    console.log("My total year of experience", yof.formatted);
    dispatch(yof_success(yof.formatted));

    let stor = store.getState();
    let p_profile = stor.profile;
    let secret = stor.secret;
    if (p_profile.message !== null) {
        if (p_profile.message?.CompletionPercentage < 95) {
            // initialize experience
            dispatch(saveExperience(sortedExperiences, secret.secret));
            dispatch(saveSkills(skills.flatMap((e) => e)));
            dispatch(uppdateYOF(yof.formatted));
        } else {
            if (flag && flag === "auto-save") {
                dispatch(updateExperience(sortedExperiences));
                dispatch(updateSkills(skills.flatMap((e) => e)));
                dispatch(uppdateYOF(yof.formatted));
            }
        }
    }
}


export const SortEducation = (Education) => async (dispatch) => {
    // Helper function to convert a date string to a Date object.
    // If the date is "Present", assign a far-future date.
    function parseEndDate(dateStr) {
      if (typeof dateStr === 'string' && dateStr.trim().toLowerCase() === "present") {
        // Use a far-future date to ensure "Present" is always the most recent.
        return new Date(3000, 0, 1); // January 1, 3000
      }
      // For other dates like "January 2023", the Date constructor can parse them.
      return new Date(dateStr);
    }

    // Sort the Education by Work_end_date in descending order.
    const sortedEducation = Education.sort((a, b) => {
      const dateA = parseEndDate(a.End_date);
      const dateB = parseEndDate(b.End_date);
      return dateB - dateA; // descending order
    });

    dispatch(dispatchEducation(sortedEducation));
  
    // Return the latest three Education.
}
